export { default as Clock } from "./Clock.component";
